import { render, staticRenderFns } from "./wechat-service-dialog.vue?vue&type=template&id=71830267&scoped=true"
import script from "./wechat-service-dialog.vue?vue&type=script&lang=js"
export * from "./wechat-service-dialog.vue?vue&type=script&lang=js"
import style0 from "./wechat-service-dialog.vue?vue&type=style&index=0&id=71830267&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71830267",
  null
  
)

export default component.exports